import { createRouter, createWebHistory } from 'vue-router'

import Login from '../views/Login.vue'
import SetPassword from '../views/SetPassword.vue'
import Registration from '../views/Registration.vue'
import otpVerification from '../views/OtpVerification.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Home from '../views/Home.vue'
import Applications from '../views/Applications.vue'
import WebSettings from '../views/WebSettings.vue'
import DeviceDetail from '../views/DeviceDetail.vue'
import Restrictions from '../views/Restrictions.vue'
import ScreenTime from '../views/ScreenTime.vue'
import Settings from '../views/Settings.vue'
import SecureBrowser from '../views/SecureBrowser.vue'
import Wipe from '../views/Wipe.vue'
import SecureChat from '../views/SecureChat.vue'

//Theme2
import ParentDashboard from '../views/theme2/dashboard.vue'

//New Kids
import DeviceDetailPage from '../views/new/DeviceDetail.vue'
import ApplicationDetail from '../views/new/ApplicationDetail.vue'
import CategoryDetail from '../views/new/CategoryDetail.vue'
import ApplicationList from '../views/new/ApplicationList.vue'
import NotFound from '../views/PageNotFound.vue'
import PaymentHistoy from '../views/new/PaymentHistoy.vue'
import PaymentMethods from '../views/new/PaymentMethods.vue'
import BrowserLogs from '../views/new/BrowserLogs.vue'
import AppRequests from '../views/new/AppRequests.vue'
import ChangePassword from '../views/new/ChangePassword.vue'
import ContactUs from '../views/new/ContactUs.vue'
import DeviceLogs from '../views/new/DeviceLogs.vue'
import ServerLogs from '../views/new/ServerLogs.vue'
import GlobalSettings from '../views/new/GlobalSettings.vue'
import DeviceInfo from '../views/new/DeviceInfo.vue'
import Reports from '../views/new/ReportsList.vue'
import ReportDetail from '../views/new/ReportDetail.vue'
import LocationSettings from '../views/new/LocationSettings.vue'
import ParentProfile from '../views/new/ParentProfile.vue'
import Schedule from '../views/new/Schedule.vue'
import CreateSchedule from '../views/new/CreateSchedule.vue'
import Contacts from '../views/new/Contacts.vue'
import GeofenceList from '../views/new/GeofenceList.vue'
import CreateGeofence from '../views/new/CreateGeofence.vue'
import GeofenceHistory from '../views/new/GeofenceHistory.vue'

const theme = localStorage.getItem('userTheme') || 'theme1';

const routes = [
  {
    path: "/",
    component: Login,
    name: "Before Auth",
    children: [
      {
        path: '/login',
        name: 'Login',
        component: Login,
      },
    ]
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
  },
  {
    path: '/password/set',
    name: 'Set Password',
    component: SetPassword,
  },
  {
    path: '/verify-otp',
    name: 'OTP Verification',
    component: otpVerification,
  },
  {
    path: '/forget-password',
    name: 'Forget Password',
    component: ForgetPassword,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
  },
  {
    path: '/device-logs',
    name: 'Device Logs',
    component: DeviceLogs,
  },
  {
    path: '/server-logs',
    name: 'Server Logs',
    component: ServerLogs,
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },

  // Theme2
  {
    path: '/parent-dashboard',
    name: 'Parent Dashboard',
    component: ParentDashboard,
  },

  // New Kids Layout
  {
    path: '/kids-device',
    name: 'Kids Devices',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/dashboard.vue');
      }
      return import('../views/new/DeviceDetail'); // theme1
    },
  },
  {
    path: '/application',
    name: 'Application',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/AppDetail.vue');
      }
      return import('../views/new/ApplicationDetail.vue');
    },
  },
  {
    path: '/category',
    name: 'Category',
    component: CategoryDetail,
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/CategoryDetail.vue');
      }
      return import('../views/new/CategoryDetail.vue');
    },
  },
  {
    path: '/play-store',
    name: 'Applications List',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/ApplicationList.vue');
      }
      return import('../views/new/ApplicationList.vue');
    },
  },
  {
    path: '/payment-history',
    name: 'payment-history',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/PaymentHistory.vue');
      }
      return import('../views/new/PaymentHistoy.vue');
    },
  },
  {
    path: '/requests',
    name: 'requests',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/AppRequests.vue');
      }
      return import('../views/new/AppRequests.vue');
    },
  },
  {
    path: '/payment-methods',
    name: 'payment-methods',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/PaymentMethods.vue');
      }
      return import('../views/new/PaymentMethods.vue');
    },
  },
  {
    path: '/browser-logs',
    name: 'browser-logs',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/BrowserLogs.vue');
      }
      return import('../views/new/BrowserLogs.vue');
    },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/ChangePassword.vue');
      }
      return import('../views/new/ChangePassword.vue');
    },
  },
  {
      path: '/audit-history',
      name: 'audit-history',
      component: () => {
        if (theme === 'theme2') {
          return import('../views/new/AuditHistory.vue');
        }
        return import('../views/new/AuditHistory.vue');
      },
  },
  {
    path: '/global-settings',
    name: 'global-settings',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/GlobalSettings.vue');
      }
      return import('../views/new/GlobalSettings.vue');
    },
  },
  {
    path: '/location-settings',
    name: 'location-settings',
    component: LocationSettings,
  },
  {
    path: '/parent-profile',
    name: 'parent-profile',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/ParentProfile.vue');
      }
      return import('../views/new/ParentProfile.vue');
    },
  },
  {
    path: '/device-info',
    name: 'device-info',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/DeviceInfo.vue');
      }
      return import('../views/new/DeviceInfo.vue');
    },
  },
  {
    path: '/device-screenshots',
    name: 'device-screenshots',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/new/Devicescreenshots.vue');
      }
      return import('../views/new/Devicescreenshots.vue');
    },
  },
  {
    path: '/refer-and-earn',
    name: 'refer-and-earn',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/new/ReferAndEarn.vue');
      }
      return import('../views/new/ReferAndEarn.vue');
    },
  },
  { path: '/location-history', component: () => import('@/views/new/LocationHistory.vue') },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/Schedules.vue');
      }
      return import('../views/new/Schedule.vue');
    },
  },
  {
    path: '/create-schedule',
    name: 'create-schedule',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/CreateSchedule.vue');
      }
      return import('../views/new/CreateSchedule.vue');
    },
  },
  {
    path: '/geofence',
    name: 'geofence',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/GeofenceList.vue');
      }
      return import('../views/new/GeofenceList.vue');
    },
  },
  {
    path: '/geofence/create',
    name: 'geofence-create',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/CreateGeofence.vue');
      }
      return import('../views/new/CreateGeofence.vue');
    },
  },
  {
    path: '/geofence/history',
    name: 'geofence-history',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/GeofenceHistory.vue');
      }
      return import('../views/new/GeofenceHistory.vue');
    },
  },
  {
    path: '/manage-chrome',
    name: 'manage-chrome',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/new/ManageChrome.vue');
      }
      return import('../views/new/ManageChrome.vue');
    },
  },
  {
    path: '/manage-password',
    name: 'manage-password',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/new/ManagePassword.vue');
      }
      return import('../views/new/ManagePassword.vue');
    },
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/new/TimelineReport.vue');
      }
      return import('../views/new/TimelineReport.vue');
    },
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/ReportList.vue');
      }
      return import('../views/new/ReportsList.vue');
    },
  },
  {
    path: '/report',
    name: 'report',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/ReportDetail.vue');
      }
      return import('../views/new/ReportDetail.vue');
    },
  },
  {
    path: '/contact-us',
    name: 'contact Us',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/Contactus.vue');
      }
      return import('../views/new/ContactUs.vue');
    },
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/Contacts.vue');
      }
      return import('../views/new/Contacts.vue');
    },
  },
  {
    path: '/call-history',
    name: 'Call History',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/Contacts.vue');
      }
      return import('../views/new/CallHistory.vue');
    },
  },
  {
    path: '/chats',
    name: 'Chats',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/Contacts.vue');
      }
      return import('../views/new/Chats.vue');
    },
  },
  {
    path: '/chat-details',
    name: 'Chats Detail',
    component: () => {
      if (theme === 'theme2') {
        return import('../views/theme2/Contacts.vue');
      }
      return import('../views/new/ChatDetail.vue');
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 }
  }
});

import UserService from "../services/UserService";
// GOOD
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem('token');
  if (isAuthenticated) {
    await UserService.userDetail()
    .then((response) => {
      }).catch((e) => {
        localStorage.setItem('token', "");
        next({ name: 'Login' })
      });
  }
  if (to.name == 'Forget Password' || to.name == 'Registration' || to.name == 'OTP Verification' || to.name == 'Reset Password') {
    next()
  } else {
    /*if (to.name !== 'Login' && !isAuthenticated) next({ name: 'Login' })
    else if (to.name == 'Login' && isAuthenticated) next({ name: 'Kids Devices' })
    else next()*/
    next()
  }
})

export default router
